import { IconProps } from "./types";

export default function IcoTrunk({
	color = "#4B5563",
	width = "10",
	height = "16"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 15 18"
			fill="none"
		>
			<path
				d="M13.333 4.286H11.667C11.667 1.92 9.8 0 7.5 0C5.2 0 3.333 1.92 3.333 4.286H1.667C0.75 4.286 0 5.053 0 6V16.286C0 17.233 0.75 18 1.667 18H13.333C14.25 18 15 17.233 15 16.286V6C15 5.053 14.25 4.286 13.333 4.286ZM7.5 1.714C8.879 1.714 10 2.867 10 4.286H5C5 2.867 6.121 1.714 7.5 1.714ZM7.5 10.286C5.2 10.286 3.333 8.366 3.333 6H5C5 7.419 6.121 8.571 7.5 8.571C8.879 8.571 10 7.419 10 6H11.667C11.667 8.366 9.8 10.286 7.5 10.286Z"
				fill={color}
			/>
		</svg>
	);
}
